/**
 * The signed-in account on this page: its user. The engine reads it
 * (engine.account); the sign-in flow sets it
 * (interfaces/classic/managers/auth-manager.js). The vault's key is not kept
 * here: it stays with the sign-in flow and the vault (no accessor an
 * interface could reach).
 */

let currentUser = null;

export function setCurrentUser(user) {
  currentUser = user;
}

export function getCurrentUser() {
  return currentUser;
}
